import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";

// namespace SlotGames {

	export class AncientSea_Responsive extends SlotGameType1_Responsive {

	
	
			
		protected override helpFactory: IHelpFactory = new AncientSeaHelpFactory();		

		//SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
		    coloroutherStroke: "black",
            colorinnerStroke: "#00AAE4",
        }
        //LED COLOR
		protected override ColorLed:string="0,0,255\n";
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName : string = "AncientSea") {
			super(multigameParams, initData, gameName );

			this.spinnableReelsParams.topBorderWidth = 10;
			this.spinnableReelsParams.bottomBorderWidth = 10;
		}
	}

	 //Help Colorized
	 class AncientSeaHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new AncientSeaHelp(params);
        }
    }

    class AncientSeaHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor:  "linear-gradient(rgb(1, 11, 64),rgb(2, 15, 89), rgb(3, 23, 140),rgb(2, 15, 89),rgb(1, 11, 64)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }


// }
